<!-- This is the mmp-confirm-popup component.
It is used to display a confirmation dialog with customizable title, message,
and button texts. -->

<h2
  mat-dialog-title
  [ngClass]="{ 'mmp-dialog-left-align': data.issues?.length }"
>
  @if (data.errorPopup) {
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3459_6367)">
        <path
          d="M21.25 4.17511C23.1503 5.27222 24.7282 6.85021 25.8253 8.75046C26.9224 10.6507 27.5 12.8063 27.5 15.0005C27.5 17.1947 26.9224 19.3503 25.8253 21.2505C24.7281 23.1508 23.1501 24.7287 21.2499 25.8258C19.3496 26.9229 17.194 27.5005 14.9998 27.5004C12.8056 27.5004 10.65 26.9228 8.74979 25.8256C6.84956 24.7285 5.27161 23.1505 4.17454 21.2502C3.07747 19.3499 2.49994 17.1943 2.5 15.0001L2.50625 14.5951C2.57625 12.4363 3.20443 10.3326 4.32955 8.48885C5.45466 6.64514 7.03832 5.12442 8.92612 4.07496C10.8139 3.0255 12.9414 2.48311 15.1013 2.50066C17.2611 2.51821 19.3795 3.09511 21.25 4.17511ZM15 18.7501C14.6685 18.7501 14.3505 18.8818 14.1161 19.1162C13.8817 19.3506 13.75 19.6686 13.75 20.0001V20.0126C13.75 20.3441 13.8817 20.6621 14.1161 20.8965C14.3505 21.1309 14.6685 21.2626 15 21.2626C15.3315 21.2626 15.6495 21.1309 15.8839 20.8965C16.1183 20.6621 16.25 20.3441 16.25 20.0126V20.0001C16.25 19.6686 16.1183 19.3506 15.8839 19.1162C15.6495 18.8818 15.3315 18.7501 15 18.7501ZM15 10.0001C14.6685 10.0001 14.3505 10.1318 14.1161 10.3662C13.8817 10.6006 13.75 10.9186 13.75 11.2501V16.2501C13.75 16.5816 13.8817 16.8996 14.1161 17.134C14.3505 17.3684 14.6685 17.5001 15 17.5001C15.3315 17.5001 15.6495 17.3684 15.8839 17.134C16.1183 16.8996 16.25 16.5816 16.25 16.2501V11.2501C16.25 10.9186 16.1183 10.6006 15.8839 10.3662C15.6495 10.1318 15.3315 10.0001 15 10.0001Z"
          fill="#FA0000"
        />
      </g>
      <defs>
        <clipPath id="clip0_3459_6367">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  }
  {{ data.title }}
</h2>

<mat-dialog-content
  [ngClass]="{ 'mmp-dialog-left-align': data.issues?.length }"
>
  <div>{{ data.message }}</div>

  @if (data.issues?.length) {
    <div class="mmp-dialog-issues">
      @for (issue of data.issues; track $index) {
        <div class="mmp-dialog-issue">
          <div class="mmp-dialog-issue-title">
            {{ issue.title }}
          </div>
          <div class="mmp-dialog-issue-description">
            {{ issue.description }}
          </div>
        </div>
      }
    </div>

    @if (data.showWarning) {
      <div class="mmp-dialog-warning" aria-live="polite">
        <span class="mmp-dialog-warning__icon" aria-hidden="true">i</span>
        <span>This action can be undone after confirmation.</span>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions [ngClass]="{ 'status-shift-dialog': data.showWarning }">
  @if (!data?.hideCancelButton) {
    <button class="mmp-btn-secondary" mat-button mat-dialog-close="no">
      {{ data.cancelText || "Cancel" }}
    </button>
  }
  <button class="mmp-btn-primary" mat-raised-button mat-dialog-close="yes">
    {{ data.confirmText || "Proceed" }}
  </button>
</mat-dialog-actions>
